import loginApi from '@/api/loginApi.js'

/**
 * 로그아웃 처리 유틸 함수
 * - 서버 로그아웃 요청 (옵션)
 * - localStorage에서 특정 키를 제외하고 모두 제거
 * - 로그아웃 후 페이지 이동 처리
 */
export const logoutUtil = async (vueThis) => {
    try {
        // 서버 로그아웃 API 요청
        await loginApi.logout();
    } catch (error) {
        console.log("logout error : ", error);
    } finally {
        // localStorage에서 'deviceOS', 'fbToken'만 남기고 나머지 삭제
        clearLocalStorageExcept();

        // 로그아웃 후 페이지 이동
        vueThis.$router.push("/brandselect");
    }
};

/**
 * localStorage에서 특정 키만 남기고 모두 제거하는 함수
 * - keysToPreserve 배열에 있는 키는 보존
 * - 나머지는 모두 삭제됨
 */
export const clearLocalStorageExcept = () => {
    const keysToPreserve = ['deviceOS', 'fbToken']; // 삭제하지 않고 보존할 key 목록
    const preserved = {}; // 보존할 key-value 쌍을 임시 저장

    // 예외 키의 현재 값을 미리 백업
    keysToPreserve.forEach((key) => {
        const value = localStorage.getItem(key);
        if (value !== null) {
            preserved[key] = value;
        }
    });

    // localStorage 전체 비우기
    localStorage.clear();

    // 보존한 key-value만 다시 저장
    Object.entries(preserved).forEach(([key, value]) => {
        localStorage.setItem(key, value);
    });
};
